import { useEffect, useRef } from "react";

export const HeroCanvas = () => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let frame;
    let pointer = { x: 0.5, y: 0.5 };
    const nodes = Array.from({ length: 56 }, (_, i) => ({
      x: Math.random(),
      y: Math.random(),
      z: 0.35 + Math.random() * 0.65,
      r: 1.2 + Math.random() * 2.2,
      phase: Math.random() * Math.PI * 2,
      amber: i % 7 === 0,
    }));

    const resize = () => {
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * window.devicePixelRatio;
      canvas.height = rect.height * window.devicePixelRatio;
      ctx.setTransform(window.devicePixelRatio, 0, 0, window.devicePixelRatio, 0, 0);
    };

    const draw = (time = 0) => {
      const { width, height } = canvas.getBoundingClientRect();
      ctx.clearRect(0, 0, width, height);
      const px = (pointer.x - 0.5) * 34;
      const py = (pointer.y - 0.5) * 24;

      nodes.forEach((n, i) => {
        const drift = reduced ? 0 : Math.sin(time / 1900 + n.phase) * 0.018;
        n.sx = (n.x + drift) * width + px * n.z;
        n.sy = (n.y + drift * 0.6) * height + py * n.z;
        for (let j = i + 1; j < nodes.length; j++) {
          const m = nodes[j];
          const dx = n.sx - m.sx;
          const dy = n.sy - m.sy;
          const dist = Math.hypot(dx, dy);
          if (dist < 128) {
            ctx.strokeStyle = `rgba(96, 165, 250, ${(1 - dist / 128) * 0.2})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(n.sx, n.sy);
            ctx.lineTo(m.sx, m.sy);
            ctx.stroke();
          }
        }
        ctx.fillStyle = n.amber ? "rgba(245,158,11,.9)" : "rgba(96,165,250,.75)";
        ctx.beginPath();
        ctx.arc(n.sx, n.sy, n.r * n.z, 0, Math.PI * 2);
        ctx.fill();
      });

      if (!reduced) frame = requestAnimationFrame(draw);
    };

    const move = (event) => {
      const rect = canvas.getBoundingClientRect();
      pointer = {
        x: (event.clientX - rect.left) / rect.width,
        y: (event.clientY - rect.top) / rect.height,
      };
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener("pointermove", move);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", resize);
      window.removeEventListener("pointermove", move);
    };
  }, []);

  return <canvas ref={ref} data-testid="hero-energy-canvas" className="absolute inset-0 h-full w-full opacity-70" aria-hidden="true" />;
};
